export enum EBathRoomTypeEnum {
  PRIVATE_BATHROOM = 'private',
  SHARED_BATHROOM = 'shared'
}

export enum EPlaceTypeEnum {
  PRIVATE_ROOM = 'private-room',
  ENTIRE_HOUSE = 'entire-house'
}
